import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "about" };
const _hoisted_2 = {
    key: 0,
    class: "about__section"
};
const _hoisted_3 = { class: "about__title" };
const _hoisted_4 = { class: "about__info" };
const _hoisted_5 = { class: "about__info__row d-flex align-items-start" };
const _hoisted_6 = { class: "about__info__label gray-text-light" };
const _hoisted_7 = { class: "about__info__value" };
const _hoisted_8 = { class: "about__info__row d-flex align-items-start" };
const _hoisted_9 = { class: "about__info__label gray-text-light" };
const _hoisted_10 = { class: "about__info__value" };
const _hoisted_11 = { class: "about__info__row d-flex align-items-start" };
const _hoisted_12 = { class: "about__info__label gray-text-light" };
const _hoisted_13 = { class: "about__info__value" };
const _hoisted_14 = {
    key: 0,
    class: "about__info__row d-flex align-items-start"
};
const _hoisted_15 = { class: "about__info__label gray-text-light" };
const _hoisted_16 = { class: "about__info__value" };
const _hoisted_17 = { class: "about__info__row d-flex align-items-start" };
const _hoisted_18 = { class: "about__info__label gray-text-light" };
const _hoisted_19 = { class: "about__info__row d-flex align-items-start" };
const _hoisted_20 = { class: "about__info__label gray-text-light" };
const _hoisted_21 = { class: "about__info__value" };
const _hoisted_22 = {
    key: 0,
    class: "about__info__row d-flex align-items-start"
};
const _hoisted_23 = { class: "about__info__label gray-text-light" };
const _hoisted_24 = { class: "about__info__value" };
const _hoisted_25 = {
    key: 1,
    class: "about__info__row d-flex align-items-start"
};
const _hoisted_26 = { class: "about__info__label gray-text-light" };
const _hoisted_27 = { class: "about__info__value" };
const _hoisted_28 = { class: "about__section" };
const _hoisted_29 = { class: "about__title" };
const _hoisted_30 = { class: "about__info" };
const _hoisted_31 = { class: "about__info__row d-flex align-items-start" };
const _hoisted_32 = { class: "about__info__label gray-text-light" };
const _hoisted_33 = {
    key: 1,
    class: "about__info__value"
};
const _hoisted_34 = { class: "about__section" };
const _hoisted_35 = { class: "about__title" };
const _hoisted_36 = { class: "about__info" };
const _hoisted_37 = { class: "about__info__row d-flex align-items-start" };
const _hoisted_38 = { class: "about__info__label gray-text-light" };
import { useStore } from "vuex";
import { computed, ref, watch } from "vue";
import { getVisibleTags } from "@/plugins/getVisible";
import DeviceStatusIcon from "@/components/devices/partials/DeviceStatusIcon.vue";
import TagBubbles from "@/components/devices/tagBubbles.vue";
import ServiceRow from "@/components/devices/partials/ServiceRow.vue";
import { client } from "@/main";
import { useAuthStore } from "@/store/modules/auth";
export default /*@__PURE__*/ _defineComponent({
    __name: 'detailTab',
    props: {
        device: {},
        service: {},
        transformationFunction: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const authStore = useAuthStore();
        const apiUser = computed(() => authStore.apiUser);
        const visibleTags = computed(() => getVisibleTags(props.device.tags, apiUser.value?.isIotAdmin) ?? []);
        const hwDevice = ref(null);
        watch(() => props.device, async () => {
            hwDevice.value = null;
            if (props.device.hwDeviceId) {
                const { data } = await client.path("/hwdevices/{hwDeviceId}").method("get").create()({
                    hwDeviceId: props.device.hwDeviceId.toString()
                });
                hwDevice.value = data.data;
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.device)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("informaceOZarizeni"))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("nazevZarizeni"))), 1),
                                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.device.name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("DEVICE_ID"))), 1),
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.device.deviceId), 1)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("Rezim"))), 1),
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(DeviceStatusIcon, {
                                        device: _ctx.device,
                                        "show-description": ""
                                    }, null, 8, ["device"])
                                ])
                            ]),
                            (visibleTags.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("tagy"))), 1),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createVNode(TagBubbles, {
                                            "tag-list": _ctx.device.tags
                                        }, null, 8, ["tag-list"])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("Typ zařízení"))), 1),
                                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "about__info__value" }, "UDP", -1))
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("TARGET_ENTRYPOINT"))), 1),
                                _createElementVNode("div", _hoisted_21, "udp.iot.cra.cz:" + _toDisplayString(_ctx.device.port), 1)
                            ])
                        ]),
                        (_ctx.transformationFunction)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("TRANSFORMATION_FUNCTION"))), 1),
                                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.transformationFunction.label), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (hwDevice.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("HW_DEVICE"))), 1),
                                _createElementVNode("div", _hoisted_27, _toDisplayString(hwDevice.value.manufacturer) + " / " + _toDisplayString(hwDevice.value.model) + " / " + _toDisplayString(hwDevice.value.revision), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("zpravyZarizeni"))), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("posledniZpravaZeZarizeni"))), 1),
                            (_ctx.device.lastMessageIn)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "about__info__value",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showMessage(_ctx.lastMessageIn)))
                                }, _toDisplayString(_ctx.$t("pred")) + " " + _toDisplayString(_ctx.$filters.beforeTime(_ctx.device.lastMessageIn, "short")), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t("neni")), 1))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("sluzbaALimity"))), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("sluzba"))), 1),
                            _createVNode(ServiceRow, { service: _ctx.service }, null, 8, ["service"])
                        ])
                    ])
                ])
            ]));
        };
    }
});
